import * as React from "react";
import {EntityFormComponentProps} from "../../../../types/entity";
import {Share} from "../../../../types/internal";

const ShareForm = ({entity, item, action}: EntityFormComponentProps<Share, any>) => {
  return null;
};

export default ShareForm;
